export const AGENT_PLATFORM_FEATURE = {
  platform: 'KNOW_AGENT_PLATFORM',
  agents: 'KNOW_AGENTS',
  tools: 'KNOW_AGENT_TOOLS',
  flows: 'KNOW_AGENT_FLOWS',
} as const;

export const AGENT_RUNTIME_IDS = {
  langGraph: 'c3000001-0000-4000-8000-000000000001',
  httpTool: 'c3000001-0000-4000-8000-000000000002',
  pgVectorKnowledge: 'c3000001-0000-4000-8000-000000000003',
  nodeRedAutomation: 'c3000001-0000-4000-8000-000000000004',
} as const;

export type AgentRuntimeId = (typeof AGENT_RUNTIME_IDS)[keyof typeof AGENT_RUNTIME_IDS];
